import React from "react";

const HMCDuo = () => {
  return (
    <svg
      width="60"
      height="61"
      viewBox="0 0 60 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_441_19043)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M31.6965 34.5931C33.7021 30.6536 37.1483 28.25 41.2503 28.25C46.9501 28.25 51.2581 32.8291 52.4328 39.643C52.5454 40.2961 52.1073 40.9168 51.4541 41.0294C50.801 41.142 50.1803 40.7039 50.0677 40.0507C49.0174 33.9584 45.3942 30.65 41.2503 30.65C38.2063 30.65 35.5118 32.3981 33.8419 35.669L33.8141 35.7271C33.5282 36.325 32.8117 36.5779 32.2138 36.2919C31.6159 36.006 31.363 35.2895 31.649 34.6916L31.6898 34.6063L31.6965 34.5931Z"
          fill="url(#paint0_radial_441_19043)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.2498 18.15C39.9105 18.15 38.626 18.6821 37.6789 19.6291C36.7319 20.5762 36.1998 21.8607 36.1998 23.2C36.1998 24.5393 36.7319 25.8238 37.6789 26.7709C38.626 27.7179 39.9105 28.25 41.2498 28.25C41.913 28.25 42.5697 28.1194 43.1824 27.8656C43.7951 27.6118 44.3518 27.2398 44.8207 26.7709C45.2896 26.302 45.6616 25.7452 45.9154 25.1326C46.1692 24.5199 46.2998 23.8632 46.2998 23.2V18.15H41.2498ZM35.9819 17.9321C37.379 16.5349 39.2739 15.75 41.2498 15.75H48.6998V23.2C48.6998 24.1783 48.5071 25.1471 48.1327 26.051C47.7583 26.9549 47.2096 27.7761 46.5178 28.4679C45.826 29.1597 45.0047 29.7085 44.1008 30.0829C43.1969 30.4573 42.2282 30.65 41.2498 30.65C39.2739 30.65 37.379 29.8651 35.9819 28.4679C34.5847 27.0708 33.7998 25.1759 33.7998 23.2C33.7998 21.2241 34.5847 19.3292 35.9819 17.9321Z"
          fill="url(#paint1_radial_441_19043)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.5 30.6812C16.5478 30.6812 11.4065 35.6712 9.93415 44.6443C9.82684 45.2983 9.20968 45.7415 8.55568 45.6342C7.90168 45.5268 7.45851 44.9097 7.56582 44.2557C9.14344 34.6413 14.9147 28.2812 22.5 28.2812C30.0865 28.2812 35.8536 34.6522 37.4341 44.2679C37.5416 44.9218 37.0986 45.5391 36.4446 45.6466C35.7907 45.7541 35.1734 45.3111 35.0659 44.6571C33.5902 35.679 28.451 30.6812 22.5 30.6812Z"
          fill="url(#paint2_radial_441_19043)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.4998 13.1813C20.4974 13.1813 18.577 13.9767 17.1611 15.3926C15.7452 16.8085 14.9498 18.7289 14.9498 20.7313C14.9498 22.7336 15.7452 24.654 17.1611 26.0699C18.577 27.4858 20.4974 28.2813 22.4998 28.2813C24.5022 28.2813 26.4226 27.4858 27.8385 26.0699C29.2544 24.654 30.0498 22.7336 30.0498 20.7313V13.1813H22.4998ZM15.4641 13.6955C17.3301 11.8296 19.8609 10.7812 22.4998 10.7812H32.4498V20.7313C32.4498 23.3702 31.4015 25.901 29.5355 27.767C27.6695 29.633 25.1387 30.6813 22.4998 30.6813C19.8609 30.6813 17.3301 29.633 15.4641 27.767C13.5981 25.901 12.5498 23.3702 12.5498 20.7313C12.5498 18.0923 13.5981 15.5615 15.4641 13.6955Z"
          fill="url(#paint3_radial_441_19043)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_441_19043"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(61.1014 54.3027) rotate(-138.1) scale(49.9652 133.964)"
        >
          <stop stop-color="#00B0CA" />
          <stop offset="1" stop-color="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_441_19043"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.8616 46.0839) rotate(-124.286) scale(47.0225 118.05)"
        >
          <stop stop-color="#00B0CA" />
          <stop offset="1" stop-color="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_441_19043"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(49.8152 63.6669) rotate(-139.548) scale(69.8546 186.023)"
        >
          <stop stop-color="#00B0CA" />
          <stop offset="1" stop-color="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_441_19043"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(40.6793 51.2943) rotate(-124.286) scale(62.8019 157.665)"
        >
          <stop stop-color="#00B0CA" />
          <stop offset="1" stop-color="#9C2AA0" />
        </radialGradient>
        <clipPath id="clip0_441_19043">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0 0.699951)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HMCDuo;
